(() => {
  const checkedCards = new WeakMap();
  const requests = new Map();
  const observedRoots = new WeakSet();
  const observedHosts = new WeakSet();
  const lifetime = 30000;
  const themeId = document.currentScript?.dataset.themeId;

  function productUrl(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return null;
    const selected = card.querySelector('select.select-dropdown')?.value;
    if (selected) url.searchParams.set('variant', selected.split('/').pop());
    const preview = themeId || new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }

  async function availability(url) {
    const key = url.href;
    const cached = requests.get(key);
    if (cached && Date.now() - cached.time < lifetime) return cached.result;
    const result = fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) })
      .then(response => {
        if (!response.ok) throw new Error('PDP unavailable');
        return response.text();
      })
      .then(html => {
        const page = new DOMParser().parseFromString(html, 'text/html');
        const button = page.querySelector('.section-main-product product-form button[name="add"][data-pdp-product-type]');
        if (!button) throw new Error('PDP availability missing');
        return button.dataset.pdpProductType !== 'Replacement Lenses' || !button.disabled;
      })
      .catch(() => false);
    requests.set(key, { time: Date.now(), result });
    return result;
  }

  async function checkCard(card, host) {
    const url = productUrl(card);
    if (!url) return;
    const previous = checkedCards.get(card);
    if (previous?.url === url.href && Date.now() - previous.time < lifetime) return;
    const check = { url: url.href, time: Date.now(), allowed: false };
    checkedCards.set(card, check);
    card.style.setProperty('display', 'none', 'important');
    const allowed = await availability(url);
    if (checkedCards.get(card) !== check || !card.isConnected) return;
    check.allowed = allowed;
    card.style.setProperty('display', allowed ? '' : 'none', allowed ? '' : 'important');
    updateHost(host);
  }

  function updateHost(host) {
    const cards = Array.from(host.shadowRoot?.querySelectorAll('.product-card') || []);
    host.toggleAttribute('data-pdp-availability-ready', cards.some(card => checkedCards.get(card)?.allowed));
  }

  function scan() {
    document.querySelectorAll('#aftersell-pdp-upsell').forEach(host => {
      if (!observedHosts.has(host)) {
        observedHosts.add(host);
        host.addEventListener('click', event => {
          const button = event.composedPath().find(node => node.matches?.('button.add-button'));
          const card = button?.closest('.product-card');
          if (card && !checkedCards.get(card)?.allowed) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
      }
      const root = host.shadowRoot;
      if (!root) return;
      if (!observedRoots.has(root)) {
        observedRoots.add(root);
        const style = document.createElement('style');
        style.textContent = '.product-card:not([data-pdp-availability-checked]) { display: none !important; }';
        root.append(style);
        new MutationObserver(scan).observe(root, { childList: true, subtree: true });
        root.addEventListener('change', scan);
      }
      root.querySelectorAll('.product-card').forEach(card => {
        card.setAttribute('data-pdp-availability-checked', '');
        checkCard(card, host);
      });
      updateHost(host);
    });
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  const startup = setInterval(scan, 250);
  setTimeout(() => clearInterval(startup), 15000);
  document.addEventListener('load', scan, true);
  window.addEventListener('pageshow', scan);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scan();
  });
  scan();
})();
